<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />

    <div class="dataRect">
      <div class="dataTitle">基础信息</div>
      <div class="line">美人鱼订单号: <span :style="'color:'+GetColorMain()">{{ data.order.mermailOrderId }}</span></div>
      <div class="line">状态: <span :style="'color:'+GetColorMain()">{{ GetEnumText('Em_DiveMermaidOrderState',data.order.state) }}</span></div>
      <div class="line">创建时间: <span :style="'color:'+GetColorMain()">{{ formatDate( data.order.createTime,'yyyy/MM/dd hh:mm',true) }}</span></div>
      <div v-if="data.order.signTime" class="line">申请签约时间: <span :style="'color:'+GetColorMain()">{{ formatDate( data.order.signTime,'yyyy/MM/dd hh:mm',true) }}</span></div>
      <div v-if="data.order.signFinishTime" class="line">完成签约时间: <span :style="'color:'+GetColorMain()">{{ formatDate( data.order.signFinishTime,'yyyy/MM/dd hh:mm',true) }}</span></div>
      <div v-if="data.order.FinishTime" class="line">完成时间: <span :style="'color:'+GetColorMain()">{{ formatDate( data.order.FinishTime,'yyyy/MM/dd hh:mm',true) }}</span></div>

      <div v-if="data.isEsignError" class="line">异常: <van-tag type="danger">签约异常,如需帮助请联系客服!</van-tag></div>
      <div v-if="data.isEsignSigning" class="line">邀约: <van-tag type="success">已邀约,请联系用户完成电子协议签订!</van-tag></div>
      <template v-if="data.priceSign>0">
        <div class="line">支付订单号: <span :style="'color:'+GetColorMain()">{{ data.payOrderId }}</span></div>
        <div class="line">费用: <span :style="'color:'+GetColorMain()">CNY {{ ShowMoney(data.priceSign) }}</span></div>
        <div class="line">支付状态:
          <van-tag v-if="data.isPayFinish===false" style="margin-left:0.5em" type="danger">待支付</van-tag>
          <van-tag v-if="data.isPayFinish===true" style="margin-left:0.5em" type="success">已支付成功</van-tag>
        </div>
      </template>
      <div v-if="data.order.isSandbox" class="line">测试: <span :style="'font-size:2em;color:'+GetColorMain()">当前订单是测试模式订单!</span></div>

      <div class="buttonRect">
        <van-button :disabled="data.order.state!=='Wait'" :loading="buttonLoading" size="small" :color="GetColorSecondary()" style="margin-left:0.5em;" @click="onDeleteOrder">删除订单</van-button>
        <van-button :disabled="data.order.state!=='Wait'" size="small" :color="GetColorMain()" style="margin-left:0.5em;" @click="onMakeSignOrder">申请签约</van-button>
        <van-button v-if="data.isPayFinish===false" size="small" :color="GetColorMain()" style="margin-left:0.5em;" @click="onPayOrder">支付费用</van-button>
      </div>
    </div>

    <div class="dataRect">
      <div class="dataTitle">顾客信息</div>
      <div class="line">
        <van-field
          v-model="data.order.loaclName"
          clearable
          label="姓名"
          placeholder="请输入姓名"
          required
          :disabled="data.order.state!=='Wait'"
          @blur="onLocalNameChange"
        />
        <van-field
          v-model="data.order.lastName"
          clearable
          label="英文姓"
          placeholder="请输入英文姓"
          required
          :disabled="data.order.state!=='Wait'"
        />
        <van-field
          v-model="data.order.firstName"
          clearable
          label="英文名"
          placeholder="请输入英文名"
          required
          :disabled="data.order.state!=='Wait'"
        />
        <van-field
          v-model="data.order.phone"
          clearable
          label="手机号码"
          placeholder="请输入手机号码"
          required
          :disabled="data.order.state!=='Wait'"
        />
        <van-field
          v-model="data.order.idCardNumber"
          clearable
          label="身份证号码"
          placeholder="请输入身份证号码"
          :disabled="data.order.state!=='Wait'"
        />
        <!-- <van-field
          v-model="data.order.passportNumber"
          clearable
          label="护照号码"
          placeholder="请输入护照号码(2选1)"
          :disabled="data.order.state!=='Wait'"
        /> -->
      </div>
      <div class="aboutInfo">你可以 <span v-clipboard:copy="copyStr" v-clipboard:success="onCopySuccess" :style="'color:'+GetColorMain()" @click="onCopyBind">点击复制链接</span> 或者通过点击右上角“...”-“发送给朋友” 发送该订单给顾客由顾客完善上述信息。</div>
      <div class="buttonRect"><van-button :loading="buttonLoading" size="small" :color="GetColorMain()" :disabled="data.order.state!=='Wait'" @click="onSaveCustomerInfo">修改顾客信息</van-button></div>
    </div>

    <div class="dataRect">
      <div class="dataTitle">预约信息</div>
      <div class="line">
        <van-field
          v-model="courseDate"
          clearable
          label="开课日期"
          required
          readonly
          placeholder="请选择开课日期"
          @click="showCourseDate=true"
        /> </div>
      <div class="line"><FieldSelect v-model="course" :list="diveCourseList" label="课程" placeholder="请选择课程" @change="onCourseChange" /></div>
      <div class="aboutInfo">如果选择课程和开课日期，在用户完成签约时将会自动创建行程订单。</div>
      <div class="buttonRect"><van-button :loading="buttonLoading" :disabled="!(data.order.state==='Wait'||data.order.state==='WaitSign'||data.order.state==='SignFinish')" size="small" :color="GetColorMain()" @click="onSaveCustomerBaseInfo">修改基本信息</van-button></div>
    </div>
    <div class="dataRect">
      <div class="dataTitle">补充信息</div>
      <div class="line">
        <van-field
          v-model="data.order.deposit"
          clearable
          label="押金"
          maxlength="128"
          type="textarea"
          autosize
          rows="1"
          placeholder="请输入押金"
        />
      </div>
      <div class="line">
        <van-field
          v-model="data.order.remarkAgent"
          clearable
          label="备注"
          maxlength="2048"
          type="textarea"
          autosize
          rows="1"
          placeholder="请输入备注"
        />
      </div>
      <div class="aboutInfo">该信息仅用于备忘,您可以记录该用户的一些信息.</div>
      <div class="buttonRect"><van-button :loading="buttonLoading" size="small" :color="GetColorMain()" @click="onSaveMoreInfo">修改补充信息</van-button></div>
    </div>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
    <dateSelect v-model="showCourseDate" :max-date="maxDate" :min-date="minDate" :default-date="courseDate" @onChange="onCourseDateChange" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton, Field, Dialog, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'
import dateSelect from '@/components/dateSelect'
import FieldSelect from '@/components/FieldSelect'

export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    TopBar,
    wxShare,
    dateSelect,
    FieldSelect
  },
  data() {
    return {
      titleTop: '',
      title: '寻找美人鱼',
      backurl: '/mermaid/agentList',
      hashId: undefined,
      data: {
        order: {}
      },
      loading: true,
      copyStr: undefined,
      system: undefined,
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      buttonLoading: false,
      diveCourseList: [],
      courseDate: undefined,
      showCourseDate: false,
      maxDate: undefined,
      minDate: undefined,
      course: undefined
    }
  },

  created() {
    this.system = getUrlKey('system')
    this.hashId = this.$route.params.id
    this.titleTop = GetSysTitle()
    this.initCourse((diveCourseData) => {
      this.minDate = new Date()
      this.maxDate = new Date()
      this.maxDate = new Date(this.maxDate.setDate(this.maxDate.getDate() + 90))
      this.courseDate = undefined
      this.init()
    })
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.loading = true
      request({
        url: '/DiveMermaid/getMermaidAgent',
        method: 'post',
        params: { id: this.hashId }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        if (this.data.order.courseStartDate) {
          this.courseDate = formatDate(this.data.order.courseStartDate, 'yyyy/MM/dd')
        }
        if (this.data.order.diveCourseId) {
          this.course = this.data.order.diveCourseId
        }
        this.initShare()
      })
    },
    initCourse(callback) {
      request({
        url: '/DiveMermaid/getMermailDiveCourse',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        var diveCourseList = []
        response.data.forEach(el => {
          diveCourseList.push({ text: el.v, value: el.k })
        })
        this.diveCourseList = JSON.parse(JSON.stringify(diveCourseList))

        if (callback) {
          callback()
        }
      })
    },
    onCopyBind() {
      this.copyStr = undefined
      var test = ''
      if (this.data.order.isSandbox) {
        test = '[测试订单]'
      }
      this.copyStr = test + '请打开链接完善个人信息完成预定: ' + GetSelfUrl() + 'mermaid/bind/' + this.data.order.hashId + '?system=' + this.system
    },
    onCopySuccess(e) {
      MyNotify('success', '已复制:' + e.text, 2000)
    },
    initShare() {
      var test = ''
      if (this.data.order.isSandbox) {
        test = '[测试订单]'
      }
      this.shareTitle = test + '寻找美人鱼-' + this.data.agentName + '报名通道'
      this.shareAbout = test + '请打开完善个人信息完成预定'
      this.shareTimeline = test + '寻找美人鱼-' + this.data.agentName + '报名通道,请打开完善个人信息完成预定'
      this.shareUrl = undefined
      this.shareUrl = GetSelfUrl() + 'mermaid/bind/' + this.data.order.hashId + '?system=' + this.system
      this.shareIcon = GetSelfUrl() + 'img/picShare.jpg'
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    onSaveMoreInfo() {
      this.buttonLoading = true
      request({
        url: '/DiveMermaid/updateMermaidAgentMoreInfo',
        method: 'post',
        data: { mermailOrderId: this.data.order.mermailOrderId,
          deposit: this.data.order.deposit,
          remarkAgent: this.data.order.remarkAgent }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '补充信息修改成功', 2000)
      })
    },
    onSaveCustomerBaseInfo() {
      this.buttonLoading = true
      request({
        url: '/DiveMermaid/updateMermaidAgentBaseInfo',
        method: 'post',
        data: this.data.order
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '基本信息修改成功', 2000)
      })
    },
    onSaveCustomerInfo() {
      if (this.data.order.phone && this.data.order.phone.length !== 11) {
        MyNotify('info', '请输入11位手机号码')
        return
      }
      if (this.data.order.idCardNumber && this.data.order.idCardNumber.length !== 18) {
        MyNotify('info', '请输入18位身份证号码')
        return
      }
      this.buttonLoading = true
      request({
        url: '/DiveMermaid/updateMermaidAgentCustomerInfo',
        method: 'post',
        data: this.data.order
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '顾客信息修改成功', 2000)
      })
    },
    onLocalNameChange() {
      if (this.data.order.loaclName) {
        this.onGetNamePy(this.data.order.loaclName, (ln, fn) => {
          this.data.order.firstName = fn
          this.data.order.lastName = ln
        })
      }
    },
    onGetNamePy(name, callback) {
      request({
        url: '/User/getNamePySpace',
        method: 'post',
        params: { name: name }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (callback) {
          callback(response.data.lastName, response.data.firstName)
        }
      })
    },
    onCourseDateChange(date) {
      if (date) {
        this.data.order.courseStartDate = date
        this.courseDate = formatDate(date, 'yyyy/MM/dd')
      } else {
        this.data.order.courseStartDate = undefined
        this.courseDate = undefined
      }
    },
    onCourseChange(select) {
      if (select) {
        this.data.order.diveCourseId = select.value
      } else {
        this.data.order.diveCourseId = undefined
      }
    },
    onDeleteOrder() {
      Dialog.confirm({
        title: '删除当前订单',
        message: '是否确认删除当前订单?'
      }).then(() => {
        this.onDeleteOrderDo()
      })
    },
    onDeleteOrderDo() {
      this.buttonLoading = true
      request({
        url: '/DiveMermaid/deleteMermailAgent',
        method: 'post',
        params: { id: this.data.order.mermailOrderId }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '订单删除成功', 2000)
        this.$router.push('/mermaid/agentList')
      })
    },
    onMakeSignOrder() {
      Dialog.confirm({
        title: '申请签约',
        message: '请核对信息后发起签约申请,一但申请将会自动扣除签约费用并自动给用户发送签约邀请。请核对无误后在提交!'
      }).then(() => {
        this.onMakeSignOrderDo()
      })
    },
    onMakeSignOrderDo() {
      this.buttonLoading = true
      request({
        url: '/DiveMermaid/updateMermaidAgentSign',
        method: 'post',
        params: { id: this.data.order.mermailOrderId }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (response.data) {
          this.$router.push('/store/pay/0?id=' + response.data)
        } else {
          MyNotify('success', '申请签约成功!待用户完成签约即可!', 8000)
          this.init()
        }
      })
    },
    onPayOrder() {
      this.$router.push('/store/pay/0?id=' + this.data.payOrderId)
    }
  }
}
</script>

<style scoped>
.dataRect{
    background-color: #fff;
    padding: 0 1em 1em 1em;
    margin-bottom: 1em;
}
.dataRect .dataTitle{
    font-size: 0.9em;
    font-weight: 700;
    line-height: 3em;
}
.dataRect .line{
    font-size: 0.8em;
    padding: 0.25em 0;
}
.dataRect .line span{
    font-weight: 700;

}
.aboutInfo{
    font-size: 0.8em;
    color: #999;
}
.aboutInfo span{
    font-weight: 700;
}
.buttonRect{
    display: flex;
    justify-content: flex-end;
    padding-top: 1em;
}
</style>
